<script setup lang="ts">
import type { ListFilterCriterion } from '@/types/listFilters'

const props = defineProps<{
  criteria: ListFilterCriterion[]
}>()

const activeCriteria = computed(() => props.criteria.filter((criterion) => criterion.selected.length > 0))
</script>

<template>
  <div class="flex flex-col gap-3" data-testid="list-toolbar">
    <div class="flex flex-wrap items-center gap-2">
      <slot name="leading" />
      <ListFilterMenu :criteria="criteria" />
      <div class="flex-1" />
      <slot name="trailing" />
    </div>
    <div v-if="activeCriteria.length" class="flex flex-wrap items-center gap-2">
      <ListFilterTag v-for="criterion in activeCriteria" :key="criterion.key" :criterion="criterion" />
    </div>
  </div>
</template>
